import { usePage } from "../../MediaContextProvider"

export const DProjects = () => {
    const page = usePage()
    const data = page.data
    return <div> page {JSON.stringify(data)}</div>
}   